<div class="queryform">
  <!-- <a href="/">LOGO</a> -->
  <div class="querycont">
    <form [formGroup]="queryForm" (ngSubmit)="goQuery()">
      <div class="blok">
        <mat-form-field>
          <mat-select
            placeholder="Database"
            formControlName="query0"
            (selectionChange)="goDB($event.value)"
          >
            <mat-option value="report" (click)="goDB('report')"
              >Report</mat-option
            >
            <mat-option value="annotation" (click)="goDB('annotation')"
              >Annotation</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="blok" *ngIf="databaseType === 'report'">
        <mat-form-field>
          <mat-select
            placeholder="Report type"
            formControlName="reportType"
            (selectionChange)="selectReportType($event.value)"
          >
            <mat-option value="all">All types</mat-option>
            <mat-option value="sentiment">Sentiment</mat-option>

            <mat-option value="entity">Entity</mat-option>

            <mat-option value="event">Event</mat-option>

            <mat-option value="other">Custom report</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </form>
  </div>
</div>
